import { classnames } from '@/helpers/general';
import { ButtonHTMLAttributes } from 'react';

import css from './Switch.module.scss';

type SwitchProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  switched: boolean;
  onChange: () => void;
  alt?: string;
};

const Switch = ({ switched, onChange, alt = '', ...props }: SwitchProps) => {
  return (
    <button
      onClick={onChange}
      aria-checked={switched}
      role="switch"
      type="button"
      className={classnames(
        css.button,
        'relative inline-flex w-[30px] items-center rounded-full border p-0.5 outline-none transition',
        switched ? 'bg-bg_brand border-bg_brand' : 'bg-bg_secondary border-border_bold',
      )}
      {...props}>
      <span className="sr-only">{alt}</span>
      <span
        className={classnames(
          'inline-block h-3 w-3 transform rounded-full transition',
          switched ? 'bg-fg_on_brand translate-x-[12px]' : 'translate-x-0 bg-white',
        )}
      />
    </button>
  );
};

export default Switch;
